<template>
  <div class="address">
    <p>
      <span v-if="address.FirstName || address.LastName">
        {{ address.FirstName }} {{ address.LastName }}
      </span>
      <span v-if="address.Address1 || address.Address2">
        {{ address.Address1 }} {{ address.Address2 }}
      </span>
      <span v-if="address.ZipPostalCode || address.City">
        {{ address.ZipPostalCode }}
        {{ address.City }},
      </span>
      <span v-if="address.CountryId || address.stateProvince">
        {{ getCountryAndStateToName('countries', address.CountryId) }}
        {{ getCountryAndStateToName('stateProvince', address.stateProvinceId) }}
      </span>
    </p>
    <p>
      <span v-if="address.Email">
        {{ address.Email }}
      </span>
      <span v-if="address.PhoneNumber">
        {{ address.PhoneNumber }}
      </span>
    </p>
  </div>
</template>

<script>
import { config } from '@/modules/core';

export default {
  name: 'Address',
  mixins: [config],
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

p span {
  margin: 0;
  display: block;
}
</style>
